module.exports = {
  xs: '500px',
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  xxl: '1500px',
  xxxl: '1800px'
}



//////////////////
// WEBPACK FOOTER
// ./tailwind.screens.js
// module id = ./tailwind.screens.js
// module chunks = main